import React, { useState, useMemo } from 'react'
import { Button, Modal, Upload, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { userSelector } from '../../../store/session'
import { createDelivery, createDeliveryFile, removeDeliveryFile } from '../../../services/delivery-file'
import { APP_STATUS_DONE } from '../../reports/constants'

const API_URL = process.env.REACT_APP_API_URL

const DeliveryFilesModal = ({ application, showModal, onChancel }) => {
  const { user } = useSelector(userSelector)
  const [stateWaChanged, setStateWaChanged] = useState(false)

  const fileList = useMemo(
    () =>
      application?.delivery?.delivery_files
        ? application?.delivery?.delivery_files
            .filter((file) => file.type === 'final')
            .map((file) => ({
              uid: file.id,
              name: file?.file?.name,
              status: APP_STATUS_DONE,
              url: `${API_URL}${file?.file?.url}`,
            }))
        : [],
    [application?.id]
  )

  const onFileRemove = (file) => {
    const fileId = file?.xhr ? file?.xhr?.data?.id : file.uid
    if (fileId) {
      return removeDeliveryFile(fileId, {
        data: {
          type: 'remove',
          user: user.id,
        },
      }).then(() => setStateWaChanged(true))
    } else {
      message.error('Ошибка при удалении файла')
      return Promise.reject('Empty file uid')
    }
  }
  const onFileUpload = ({ onSuccess, onProgress, onError, file }, type) => {
    const promise = new Promise((resolve, reject) => {
      if (application?.delivery?.id) {
        resolve(application?.delivery?.id)
      } else {
        createDelivery({
          data: {
            user: user.id,
            application: application?.id,
          },
        })
          .then((response) => {
            resolve(response?.data?.id)
          })
          .catch((e) => {
            reject(e)
          })
      }
    })

    promise
      .then((deliveryId) => {
        const formData = new FormData()

        const data = {
          user: user.id,
          type,
          delivery: deliveryId,
        }
        formData.append('data', JSON.stringify(data))
        formData.append('files.file', file, file.name)

        return createDeliveryFile({
          data: formData,
        })
      })
      .then((response) => {
        setStateWaChanged(true)
        onSuccess(file, response)
      })
      .catch((error) => {
        message.error('Ошибка при загрузке файла')
        onError(error)
      })
  }
  const onCancelHandler = () => {
    onChancel(stateWaChanged)
  }
  return (
    <Modal
      title="Файлы ТТН"
      visible={showModal}
      onCancel={onCancelHandler}
      footer={[
        <Button key="back" onClick={onCancelHandler}>
          Закрыть
        </Button>,
      ]}
    >
      <Upload
        fileList={fileList}
        onRemove={onFileRemove}
        customRequest={(e) => onFileUpload(e, 'final')}
        showUploadList={{
          showRemoveIcon: true,
        }}
      >
        <Button icon={<UploadOutlined />}>Загрузить ТТН</Button>
      </Upload>
    </Modal>
  )
}

export default DeliveryFilesModal
